<template>
  <vue-simple-context-menu
    elementId="context-menu-data-source-select"
    :options="ctxMenuDataSourceOptions"
    :ref="'ctxMenuDataSelect'"
    @option-clicked="ctxMenuDataSourceSelect"
  />
</template>

<script>
import { mapState } from 'vuex'
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'
import VueSimpleContextMenu from 'vue-simple-context-menu'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  components: {
    VueSimpleContextMenu,
  },
  data() {
    return {
      event: null,
      el: null,
      curPos: null,
    }
  },
  computed: {
    ...mapState(['dataGrid_options']),
    ctxMenuDataSourceOptions() {
      const list = []

      if (this.dataGrid_options) {
        for (let grid in this.dataGrid_options) {
          const value = `$getGrid('${grid}')`
          const name = 'List > ' + this.dataGrid_options[grid].title

          list.push({ name, value })
        }

        for (let grid in this.dataGrid_options) {
          var meta = this.dataGrid_options[grid].meta
          var gridtitle = this.dataGrid_options[grid].title

          if (!meta) continue

          Object.keys(meta).forEach(function(key) {
            const value = `$sum('${grid}', '${key}')`
            const name = '$ Sum ' + gridtitle + '.' + meta[key].displayName

            list.push({ name, value })
          })

          const value = `$sum('${grid}', '$count')`
          const name = '$ Count ' + gridtitle

          list.push({ name, value })
        }
      }

      if (this.computedProps) {
        for (let prop in this.computedProps) {
          const value = 'Computed > ' + prop
          const name = prop

          list.push({ name, value })
        }
      }

      return list
    },
  },
  methods: {
    show({ event, el, curPos }) {
      this.el = el
      this.curPos = curPos

      this.$refs.ctxMenuDataSelect.showMenu(event)
    },
    ctxMenuDataSourceSelect(selected) {
      this.insertTextAtCursor(this.el, selected.option.value, this.curPos)
    },
    insertTextAtCursor(el, text, offset) {
      if ($(el).hasClass('CodeMirror')) {
        const codemirror = el.CodeMirror

        codemirror.replaceRange(text, offset)
      } else {
        let val = el.value,
          endIndex,
          range,
          doc = el.ownerDocument
        if (
          typeof el.selectionStart == 'number' &&
          typeof el.selectionEnd == 'number'
        ) {
          endIndex = el.selectionEnd
          el.value = val.slice(0, endIndex) + text + val.slice(endIndex)
          el.selectionStart = el.selectionEnd =
            endIndex + text.length + (offset.start ? offset.start : 0)
        } else if (doc.selection != 'undefined' && doc.selection.createRange) {
          el.focus()
          range = doc.selection.createRange()
          range.collapse(false)
          range.text = text
          range.select()
        }
      }
    },
  },
  created() {
    eventBus.$on('showDataSelect', this.show)
  },
  beforeDestroy() {
    eventBus.$off('showDataSelect', this.show)
    this.event = null
    this.curPos = null
    this.el = null
  },
}
</script>
